import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import { toastAlert } from "@paylixecommerce/shared/components";
import { getThemeFontsAction } from "../../context/actions";
import { Popper, TextField, Autocomplete } from '@mui/material';

const KeyboardArrowDownIcon = () => null

const SettingsSelectFont = ({ id, label, initialValue, onChange }) => {
  const { name: shopName } = useSelector(({ auth }) => auth?.shop);
  const dispatch = useDispatch();

  const [value, setValue] = useState({
    title: initialValue.fontFamily,
    value: initialValue.fontFamily,
  });
  const [fonts, setFonts] = useState(null);
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getFontData = selectedFont => {
    const fontLink = [];
    fontLink.push('https://fonts.googleapis.com/css2?family=');
    fontLink.push(selectedFont.family.replace(/ /g, '+'));
    fontLink.push(':wght@');

    selectedFont.variants.forEach((variant, idx) => {
      if (variant === 'regular') {
        fontLink.push('400');
      }

      if (!variant.includes('italic') && variant !== 'regular') {
        fontLink.push(variant);
      }

      fontLink.push(
        selectedFont.variants.length - 1 !== idx && !variant.includes('italic')
          ? ';'
          : '',
      );
    });

    return {
      href: `${fontLink.join('')}&display=swap`,
      fontFamily: selectedFont.family,
      systemFont: selectedFont.category,
    };
  };

  const handleChange = (_, newValue) => {
    const selectedFont = fonts.find(({ family }) => family === newValue.value);

    setValue(newValue);
    onChange(id, getFontData(selectedFont));
  };

  const getFonts = async () => {
    try {
      const { data } = await dispatch(getThemeFontsAction({ shopName }));

      const allowedFonts = data.items.filter(({ variants }) =>
        variants.includes('300', 'regular', '500', '600', '700'),
      );

      const options = allowedFonts.map(({ family }) => ({
        title: family,
        value: family,
      }));

      setFonts(allowedFonts);
      setOptions(options);
    } catch (error) {
      return toastAlert('error', 'Something went wrong');
    }

    setIsLoading(false);
  };

  useEffect(() => {
    getFonts();
  }, []);

  return (
    <div className="mb-4">
      <div className="paylixecommerce-label">
        {label}
      </div>

      <Autocomplete
          className="builder-autocomplete"
        fullWidth
        disableClearable
        options={options}
        loading={isLoading}
        selectOnFocus={false}
        popupIcon={<KeyboardArrowDownIcon />}
        PopperComponent={Popper}
        getOptionLabel={option => option.title}
        isOptionEqualToValue={(option, newValue) =>
          option.title === newValue.title
        }
        value={value}
        onChange={handleChange}
        renderInput={params => (
          <TextField
              className="builder-text-field"
            placeholder="Select font"
            {...params}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </div>
  );
};

export default SettingsSelectFont;
